<template>
  <ItemCardPrimary
    buttonLabel="Select"
    buttonMinWidth="62px"
    :backgroundColor="backgroundColor"
    :header="tenantTeam.name"
    :onClick="selectTenantTeam"
  >
    <template v-slot:content>
      <div :style="style.contentContainer">
        <div
          v-if="!isAdmin"
          :style="style.admin"
        >
          <TextSmallPrimary
            :truncate="true"
            :style="style.text"
          >
            Created by {{ tenantTeam.admin.user.firstName }} {{ tenantTeam.admin.user.lastName }}
          </TextSmallPrimary>
        </div>
        <div :style="style.preview">
          <template v-if="tenantTeam.representatives.length">
            <div :style="style.imageContainer">
              <OverlayingUserImages
                imageHeight="24px"
                imageWidth="24px"
                :users="tenantTeam.representatives"
              />
            </div>
          </template>
          <div :style="getTextContainerStyle">
            {{ tenantTeam.tenantUserCount }} user<span v-if="tenantTeam.tenantUserCount > 1">s</span>
          </div>
        </div>
      </div>
    </template>
  </ItemCardPrimary>
</template>

<script>
  import ItemCardPrimary from '@modules/card/item-card-primary'
  import OverlayingUserImages from '@modules/image/overlaying-user-images'
  import TextSmallPrimary from '@modules/v2/text/text-small-primary'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TenantTeamCard',
    components: {
      ItemCardPrimary,
      OverlayingUserImages,
      TextSmallPrimary,
    },
    props: {
      tenantTeam: {
        type: Object,
        required: false,
        default: () => {},
      },
      tenantUser: {
        type: Object,
        required: false,
        default: () => { return {}; },
      },
    },
    data: function () {
      return {
        style: {
          admin: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          contentContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          },
          imageContainer: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            height: '100%',
            justifyContent: 'flex-end',
            margin: `0 0 12px 0`,
          },
          preview: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            margin: `${Layout.space.lg} 0`,
            width: '100%',
          },
          text: {
            width: 'fit-content',
          },
        },
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      backgroundColor: function () {
        return this.isAdmin ? null : this.color.shadow1();
      },
      getTextContainerStyle: function () {
        return {
          alignItems: 'center',
          display: 'flex',
          flex: 1,
          height: '100%',
          justifyContent: this.tenantTeam.representatives.length > 0 ? 'flex-start' : 'center',
          margin: ' 0 0 12px 0',
          padding: `0 0 0 ${Layout.space.sm}`,
        };
      },
      isAdmin: function () {
        return (
          this.tenantTeam.admin.id === this.tenantUser.id
        );
      },
    },
    methods: {
      selectTenantTeam: function () {
        this.$router.push({
          name: 'teamup-team',
          params: {
            code: this.tenantTeam.code,
          },
        });
      },
    },
  };
</script>
